import { palette, colors, theme } from "./colors";
import { spacing } from "./spacing";
import { fontSize, fontSizeValues } from "./typography";
import { radius } from "./radius";
import { shadows } from "./shadows";
import { gradients } from "./gradients";

const toCssVars = (obj: Record<string, string>, prefix: string) =>
  Object.entries(obj)
    .map(([key, value]) => `--${prefix}-${key}: ${value};`)
    .join("\n");

export const cssVariables = `
:root {
${toCssVars(palette.brand, "brand")}
${toCssVars(palette.product, "product")}
${toCssVars(spacing, "spacing")}
${toCssVars(fontSizeValues, "font-size")}
${toCssVars(radius, "radius")}
${toCssVars(shadows, "shadow")}
--grad-accent: linear-gradient(90deg, #12D6D6 0%, #47E7E7 50%, #12D6D6 100%);
}
[data-theme="dark"] {
${toCssVars(theme.dark, "color")}
}
[data-theme="light"] {
${toCssVars(theme.light, "color")}
}
`;
export { colors, spacing, fontSize, radius, shadows, gradients, palette, theme };
